var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"login-container position"},[_vm._m(1),_c('div',{staticClass:"right-section"},[_c('router-view')],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nocode-background position"},[_c('div',{staticClass:"overlay"}),_c('div',{staticClass:"content"})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-section"},[_c('div',{staticClass:"left-side-image-box"},[_c('img',{attrs:{"src":require("./register.png")}})])])
}]

export { render, staticRenderFns }